module.exports = __webpack_public_path__ + "static/media/iphone-1451614_1280.ca1ca879.png";